export default "__VITE_ASSET__CyxJ_kNO__"